<template>
  <div class="Firmware-version">
    <pageTitle v-bind="{ ...pT }" />
    <business-group
      ref="businessGroup"
      :tableConfig="{ ...tableConfig }"
      :formConfig="{ ...formConfig }"
    >
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-input
            placeholder="请输入版本号/开发商/固件上传人"
            v-decorator="['keyword']"
            style="width: 250px; margin-right: 10px; vertical-align: middle"
          />
        </a-form-item>
        
         <a-form-item>
          <a-select placeholder="请选择型号" v-decorator="['deviceModel']" style="width: 150px"  optionFilterProp="children"
            show-search >
            <a-select-option v-for="el in DeviceSelect" :value="el.id" :key="el.id">{{
               el.name
            }}</a-select-option>
           </a-select>
        </a-form-item>
        <a-form-item>
          <a-select
            placeholder="请选择更新设备类型"
            v-decorator="['updateType']"
            style="width: 150px"
          >
            <a-select-option v-for="el in updateType" :value="el.value" :key="el.id">{{
              el.label
            }}</a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <template slot="formRight">
        <a-button type="primary" @click="add">新增</a-button>
      </template>
      <template slot="deviceModel" slot-scope="record">
        {{ getDeviceModelName(record) }}
      </template>
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="edit(record)">编辑</a-button>
        <a-button type="link" @click="del(record)">删除</a-button>
      </template>
    </business-group>
    <a-modal
      :visible="visible"
      :title="title"
      :width="800"
      destroyOnClose
      @ok="submitForm('ruleForm')"
      @cancel="resetForm('ruleForm')"
      :maskClosable="false"
    >
      <a-form-model
        ref="ruleForm"
        class="Firmware-version_ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="设备型号" prop="deviceModel">
          <a-select
            placeholder="请选择设备型号"
            v-model="ruleForm.deviceModel"
            has-feedback
            autocomplete="off"
            optionFilterProp="children"
            show-search
          >
            <a-select-option v-for="el in DeviceSelect" :value="el.id" :key="el.id">{{
              el.name
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="更新设备类型" prop="updateType">
          <a-select
            placeholder="请选择更新设备类型"
            v-model="ruleForm.updateType"
            has-feedback
            autocomplete="off"
          >
            <a-select-option v-for="el in updateType" :value="el.value" :key="el.id">{{
              el.label
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="固件升级类型" prop="sellitemmenu">
          <a-select  v-model="ruleForm.sellitemmenu" placeholder="请选择固件升级类型" >
            <a-select-option v-for="el in sellitemmenuArray" :key="el.label" :value="el.value">
              {{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="版本号" prop="versionCode">
          <a-input type="text" placeholder="请输入版本号 x.x.x" v-model="ruleForm.versionCode" :disabled="!nowTitleIsNew"/>
        </a-form-model-item>
        <a-form-model-item label="开发商" prop="developer">
          <a-input type="text" placeholder="请输入开发商" v-model="ruleForm.developer" disabled />
        </a-form-model-item>
        <a-form-model-item label="更新包大小" prop="packageSize">
          <a-input type="text" placeholder="请上传更新包" disabled v-model="ruleForm.packageSize" />
        </a-form-model-item>
        <a-form-model-item label="上传更新包" prop="downloadUrl">
          <!--          list-type="picture-card"-->
          <!--          class="avatar-uploader"-->
          <!--          :show-upload-list="false"-->
          <!--          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"-->
          <!--          :before-upload="beforeUpload"-->
          <!--          @change="handleChange"-->
          <a-upload
            name="avatar"
            :before-upload="beforeUpload"
            v-model="ruleForm.downloadUrl"
            :remove="remove"
            :file-list="files"
            class="m-upload"
            :disabled="!nowTitleIsNew"
          >
            <a-icon v-if="files.length <= 0" :type="upLoading ? 'loading' : 'plus'" />
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="上市时间" prop="marketDate">
          <a-date-picker v-model="ruleForm.marketDate" :format="dateFormat" />
        </a-form-model-item>
        <a-form-model-item label="更新说明" prop="updateLog">
          <a-textarea
            placeholder="请输入更新说明"
            :rows="4"
            :maxLength="2048"
            v-model="ruleForm.updateLog"
          />
        </a-form-model-item>
        <a-form-model-item label="版本详细说明（富文本）" prop="versionDetailRichText">
          <edit-components
            v-if="visible"
            :content="ruleForm.versionDetailRichText"
            :html-change="onVersionDetailRichTextChange"
            :uploadImg="uploadRichTextImg"
            :upload-path="richTextUploadPath"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import SparkMD5 from "spark-md5";
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import formTime from "@/components/business/Form/formTime";
import formSkeleton from "@/components/business/Form/formSkeleton";
import editComponents from "@/components/EditComponents";
import { deviceType, updateType } from "@/utils/pageMaps";
import { confirm, tips } from "@/utils/util";
import { deviceSelect } from "@/utils/api";
import moment from "moment";
import { multipartUpload } from "@/utils/Oss";
import {ossConfig}from "@/utils/ali-oss"
export default {
  components: {
    pageTitle,
    businessGroup,
    formTime,
    formSkeleton,
    editComponents,
  },
  name: "Firmware-version",
  created() {
    this.getDeviceSelect();
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };
    let versionCode = (rule, value, callback) => {
      let reg = /^\d+\.\d+|.\d+$/;
      if (!reg.test(value)) {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };
    return {
      deviceType,
      updateType,
      upLoading: false,
      title: undefined,
      abort: undefined,
      files: [],
      DeviceSelect: [], // 型号
      dateFormat: this.$root.$data.dateFormat,
      nowVersionCode: undefined, //当前弹窗的型号
      nowTitleIsNew: false, //当前弹窗类型
      fileName: "",
      pT: {
        pageTitle: "工厂固件版本列表",
        // headerTitle: "更新时间",
        // text: "(单次操作不超过1年)"
      },
      tableConfig: {
        url: "/bluetoothlight/web/version/versions/firmware?departmentType=2",
        columns: [
          {
            title: "版本号",
            dataIndex: "versionCode",
            key: "versionCode",
            align: "center",
          },
          {
            title: "更新设备类型",
            dataIndex: "updateType",
            key: "updateType",
            align: "center",
          },
          {
            title: "型号",
            key: "deviceModel",
            align: "center",
            scopedSlots: { customRender: "deviceModel" },
          },
          {
            title: "开发商",
            dataIndex: "developer",
            key: "developer",
            align: "center",
          },
          {
            title: "固件升级类型",
            dataIndex: "sellitemmenu",
            key: "sellitemmenu",
            align: "center"

          },
          {
            title: "固件上传人",
            dataIndex: "creator",
            key: "creator",
            align: "center",
          },
          {
            title: "更新包大小",
            dataIndex: "packageSize",
            key: "packageSize",
            align: "center",
          },
          {
            title: "下载次数",
            dataIndex: "downloadTimes",
            key: "downloadTimes",
            align: "center",
          },
          {
            title: "更新日期",
            dataIndex: "createTime",
            key: "createTime",
            align: "center",
          },
          {
            title: "上市时间",
            dataIndex: "marketDate",
            key: "marketDate",
            align: "center",
          },
          {
            title: "操作",
            align: "center",
            width: 150,
            scopedSlots: { customRender: "action" },
          },
        ],
        rowKey: "versionId",
      },
      formConfig: {
        timeShow: true,
        formShow: true,
      },

      pageLoading: false,
      loading: false,
      visible: false,
      ruleForm: {
        // packageSize 默认为禁用 文件上传成功之后回显
      },
      sellitemmenuArray: [
        {value: '强制升级', label: '强制升级'},
        {value: '非强制升级', label: '非强制升级'},
      ],
      rules: {
        deviceModel: [
          { required: true, validator: validatePass, trigger: "change", message: "请选择设备型号" },
        ],
        updateType: [
          { required: true, validator: validatePass, trigger: "change", message: "请选择更新类型" },
        ],
        sellitemmenu: [
          { required: true, validator: validatePass, trigger: "change", message: "请选择固件升级类型" }
        ],
        developer: [
          { required: true, validator: validatePass, trigger: "change", message: "请输入开发商" },
        ],
        
        versionCode: [
          {
            required: true,
            validator: versionCode,
            trigger: "change",
            message: "请输入正确得版本号",
          },
        ],
        packageSize: [
          { required: true, validator: validatePass, trigger: "change", message: "请上传更新包" },
        ],
        marketDate: [
          { required: true, validator: validatePass, trigger: "change", message: "请选择上市时间" },
        ],
        updateLog: [
          { required: true, validator: validatePass, trigger: "change", message: "请输入更新说明" },
        ],
        // downloadUrl: [{ required: true, validator: validatePass, trigger: "change", message: "请上传更新包" }]
      },

      refresh: false,

      upUserList: [],
      richTextUploadPath: "bluetooth_light/firmware_version_richtext"
    };
  },
  methods: {
    moment,
    add() {
      this.title = "新增";
      this.visible = true;
      this.ruleForm = {
        developer: "NEEWER",
        versionDetailRichText: ""
      };
      this.nowTitleIsNew = true;
    },
    details: async function (id) {
      if (this.loading) return false;
      this.loading = true;
      const res = await this.$get(`bluetoothlight/web/version/versions/firmware/${id}`);
      this.loading = false;
      return res?.resultData || {};
    },
    // 编辑  deviceModel 转了 number
    edit: async function (record) {
      this.nowTitleIsNew = false;

      const data = await this.details(record?.versionId);

      const { dateFormat } = this;
      const marketDate = moment(data?.marketDate || new Date(), dateFormat); // 处理时间
      const { packageName, versionCode, downloadUrl, deviceModel } = data;
      // const { deviceModel } = record;
      // 回显更新包链接
      this.files = [
        {
          uid: versionCode || "-1",
          name: packageName || "更新包",
          status: "done",
          url: downloadUrl,
        },
      ];
      this.ruleForm = {
        ...data,
        marketDate,
        deviceModel: +deviceModel,
        versionDetailRichText: data.versionDetailRichText ?? ""
      };
      this.nowVersionCode = this.ruleForm.versionCode;
      this.title = "编辑";
      this.visible = true;
    },
    // 删除  关键词  rowKey
    del(record) {
      const versionId = record?.versionId;
      if (!versionId || this.pageLoading) return false;

      this.pageLoading = true;

      const payload = {
        okBack: async () => {
          const res = await this.$http(
            "DELETE",
            `/bluetoothlight/web/version/versions/firmware/${versionId}`
          );
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.refreshData();
          }
        },
        title: `是否删除该版本`,
      };
      confirm(this, payload);
      this.pageLoading = false;
    },
    // 验证表单和提交数据
    submitForm(formName) {
      if (!this.nowTitleIsNew && this.ruleForm.versionCode < this.nowVersionCode) {
        this.$message.error("修改后的版本号不得小于初始版本号！");
        return false;
      }
      if (!formName) return false;
      this.$refs[formName].validate(async (valid) => {
        if (!valid) return false;

        let marketDate = this.ruleForm?.marketDate;
        if (marketDate) {
          marketDate = moment(marketDate).format(this.dateFormat);
        }
        const res = await this.$post(
          `/bluetoothlight/web/version/versions/firmware/${this.ruleForm.versionId || 0}`,
          {
            ...this.ruleForm,
            marketDate,
            packageName: this.ruleForm.packageName || this.fileName,
            departmentType:2,
            // downloadUrl:this
          }
        );
        const resultStatus = res?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.visible = false;
          this.refreshData();
          this.resetForm("ruleForm");
        }
      });
    },
    // 重置表单和隐藏 modal
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.visible = false;
      this.ruleForm = {};
      this.files = [];
      if (this.upLoading) {
        this.upLoading = false;
        this.abort && this.abort();
      }
    },
    // 刷新table数据
    onVersionDetailRichTextChange(html) {
      this.ruleForm.versionDetailRichText = html;
    },
    uploadRichTextImg: async function(file, callback, contextPath) {
      const res = await multipartUpload(file?.name, file, null, contextPath || "bluetooth_light");
      const resultStatus = res?.resultStatus;
      if (!resultStatus) {
        tips(this, resultStatus, res.name === "cancel" ? "上传已取消" : "上传失败");
        return false;
      }
      callback && callback?.(res?.url);
    },
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    },
    // 获取设备型号
    getDeviceSelect: async function () {
      const res =  await deviceSelect();
      this.DeviceSelect = res?.resultData || [];
    },

    /**
     *  根据id 获取对应的 name, 返回结果 String
     *  @param {String || Number} val
     *  val  === String 时 需要转 Number
     * */
    getDeviceModelName(val) {
      if (val === "" || val === undefined || val === null) return "";
      const { DeviceSelect } = this;
      if (!DeviceSelect || !DeviceSelect.length) return "";
      return DeviceSelect?.find((el) => el.id === +val.deviceModel)?.name || "";
    },

    cancel(cancel) {
      this.abort = cancel;
      return cancel;
    },
    UploadClient: async function (file) {
      //console.log(file);
      this.fileName ="Plantfirmware/" + new Date().getTime()+ '-' + (file?.name || file?.uid)?.replace(".xlsx", "");
      this.upLoading = true;
      const res = await multipartUpload(this.fileName, file, this.cancel);
      //console.log(res);
      const resultStatus = res?.resultStatus;
      if (!resultStatus) {
        this.upLoading = false;
        tips(this, resultStatus, res.name === "cancel" ? "上传已取消" : "上传失败");
        return false;
      }
      // const res = await multipartUpload(this.fileName, file, this.cancel);
      if (!this.visible) return false; // 上传开始之后, 关闭了弹窗则阻止数据更新。应该是 取消 client的上传
      this.files = [{ ...res, uid: file?.uid }];

      // 计算md5
      const sliceLength = 10;
      const chunkSize = Math.ceil(file.size / sliceLength);
      const fileReader = new FileReader();
      const md5 = new SparkMD5();
      let index = 0;
      const loadFile = () => {
        const slice = file.slice(index, index + chunkSize);
        fileReader.readAsBinaryString(slice);
      };
      loadFile();
      fileReader.onload = (e) => {
        md5.appendBinary(e.target.result);
        if (index < file.size) {
          index += chunkSize;
          loadFile();
        } else {
          this.ruleForm.firmwareEncrypt = md5.end();
        }
      };

      this.ruleForm.downloadUrl = res?.url;
      this.ruleForm.packageSize = file?.size;

      this.upLoading = false;
    },
    /**
     *  文件上传处理 返回结果时 false, 结束upload的事件
     *  @param {File} file
     *  fileName 获取文件的 name或者id
     *  client 上传到oss 返回  {url,name}
     * */
    beforeUpload(file) {
      this.UploadClient(file);

      return false;
    },
    remove() {
      this.ruleForm.downloadUrl = undefined;
      this.ruleForm.packageSize = undefined;
      this.files = [];
    },
  },
};
</script>

<style lang="less">
.m-upload {
  .ant-upload-select {
    width: 60px;
    height: 60px;
    border: 1px solid #c3c3c3;
    text-align: center;
    line-height: 60px;
  }

  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
}

.Firmware-version_ruleForm {
  width: 100%;
  margin: 0 auto;

  .ant-form-item-children,
  .ant-calendar-picker {
    width: 100%;
  }
}
</style>

